import { Button } from "@sellar-io/components";
import { IntegrationCard } from "./IntegrationCard";
import { Icon } from "../../../../../components/lib/components/Icon/Icon";
import { useNavigate } from "react-router";
import { BUSINESS_INTEGRATION_RYFT_NON_HOSTED_DASHBOARD } from "~/constants/routes";

export const RyftNonHostedOnboardingSettings = () => {
  const navigate = useNavigate();

  const getConfigurationRoute = () => {
    navigate(BUSINESS_INTEGRATION_RYFT_NON_HOSTED_DASHBOARD);
  };

  return (
    <IntegrationCard
      appImage={
        "https://sellar.imgix.net/sellar-image-assets/app-assets/ryft-logo.png"
      }
      title="Ryft"
      description="Receive and manage payouts for orders paid for by Card payments and Sellar Credit."
      actions={
        <>
          <Button onClick={getConfigurationRoute}>
            <Icon icon="COG" />
            Configure
          </Button>
        </>
      }
    />
  );
};
